import * as yup from "yup"

export const detailValidation = yup.object().shape({
    adjusmentDetail: yup.array().required().min(1).of(yup.number().required())
})

export const AdjustmentInventoryValidation = yup.object().shape({
    trx_code: yup.string().defined(),
    location_id: yup.string().label("Location").required(),
    employee_id: yup.string().label("Employee").required(),
    transaction_date: yup.string().label("Date").required(),
    memo: yup.string().label("Memo").required(),
    adjusmentDetail: yup.array().label("List Item").required().min(1).of(
       yup.object().shape({
         product_id: yup.number().defined(),
         mr_unit_id: yup.number().defined(),
         soh_count: yup.number().optional(),
         last_soh: yup.number().optional(),
         avg_price_use: yup.number().defined(),
         coa_inventory_id: yup.number().defined(),
         coa_coex_id: yup.number().defined(),
         coa_inventory_code: yup.string().defined(),
         coa_inventory_name: yup.string().defined(),
         coa_coex_code: yup.string().defined(),
         coa_coex_name: yup.string().defined(),
         stock_in: yup.number().defined().optional(),
         stock_out: yup.number().defined().optional(),
         quantity_unit_sell_convention: yup.number().optional( ),
         position: yup.number().defined(),
         unit_convention_name: yup.string().optional(),
         soh: yup.number().optional(),
         product_barcode: yup.string().defined(),
         product_name: yup.string().defined(),
         mr_unit_name: yup.string().defined(),
         different_adjustment: yup.number().defined(),
         different_unit: yup.number().defined(),
         different: yup.number().optional(),
         amount_adjustment: yup.number().defined(),
         adjustment_detail_id: yup.number().defined().optional()
       })
     ),
     attach_file: yup.array().label("List Attachment").optional().of(
      yup.object().shape({
        file_path: yup.string().optional(),
        adjustment_id: yup.number().optional()
      }).optional()
    )
})

export type AdjustmentInventoryType = yup.InferType<typeof AdjustmentInventoryValidation>
export type AdjustmentInventoryDetailType = yup.InferType<typeof detailValidation>